import { cn } from '@listening/utils/react-helpers';
import ListeningLogo from '@listening/assets/imgs/logo/listeningLogoLongDark.svg?react';

export function FunnelShell({ children }: { children: React.ReactNode }) {
  return (
    <main className='flex h-dvh min-h-0 flex-col items-center overflow-hidden bg-navy-800 bg-[radial-gradient(1200px_560px_at_50%_-10%,#1a1466_0%,#0f0140_42%,#080124_100%)] px-4 pt-[max(1rem,env(safe-area-inset-top))] pb-[max(1rem,env(safe-area-inset-bottom))] font-sans text-neutral-900 sm:h-auto sm:min-h-screen sm:overflow-visible sm:pt-6 sm:pb-10'>
      <div className='mb-3 flex w-full max-w-[720px] shrink-0 items-center justify-between sm:mb-5'>
        <ListeningLogo
          aria-label='Listening'
          className='h-[30px] w-auto'
          role='img'
        />
      </div>
      {children}
    </main>
  );
}

export function FunnelCard({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex min-h-0 w-full max-w-[540px] flex-initial flex-col overflow-hidden rounded-[20px] bg-white p-5 shadow-[0_20px_50px_rgba(8,1,36,0.3)] sm:block sm:flex-none sm:overflow-visible sm:p-8',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function FunnelStepScrollArea({ children }: React.PropsWithChildren) {
  return (
    <div className='min-h-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-contain sm:overflow-visible'>
      {children}
    </div>
  );
}
